import { render } from "./InventoryView.vue?vue&type=template&id=58ab2915"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__